import { FunctionComponent } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next/pages";
import LogoStrip from "components/home/LogoStrip";
import styles from "../../styles/contact/ContactNextStep.module.css";

interface FooterLink {
  label: string;
  href: string;
}

const ContactNextStep: FunctionComponent = () => {
  const { t } = useTranslation("contact");
  const links = t("nextStep.links", { returnObjects: true }) as FooterLink[];

  return (
    <footer className={styles.section} aria-labelledby="contact-next-step">
      <div className={styles.shell}>
        <div className={styles.panel}>
          <div className={styles.copy}>
            <p className={styles.eyebrow}>{t("nextStep.eyebrow")}</p>
            <h2 id="contact-next-step" className={styles.title}>
              {t("nextStep.title")}
            </h2>
            <p className={styles.description}>{t("nextStep.description")}</p>
          </div>

          <a
            className={styles.button}
            href={t("common:global.calendlyLink")}
            target="_blank"
            rel="noopener noreferrer"
            data-umami-event="booking-link-click"
          >
            {t("nextStep.cta")} <span aria-hidden="true">↗</span>
          </a>
        </div>

        <div className={styles.linkBar}>
          <span>{t("nextStep.tagline")}</span>
          <nav className={styles.links} aria-label={t("nextStep.footerNavLabel")}>
            {links.map((link) => (
              <Link key={link.href} href={link.href}>{link.label}</Link>
            ))}
          </nav>
        </div>

        <LogoStrip variant="contact" note={t("nextStep.partnersNote")} />
      </div>
    </footer>
  );
};

export default ContactNextStep;
